import { createGlobalStyle } from 'styled-components';

// ATTENTION:
//  This file is for app-level global styles only.
//  Do not put component-specific styles in this file.

const GlobalStyle = createGlobalStyle`
    [data-tooltip] {
    position: relative;
    
    &:hover::before {
        opacity: 1;
    }
    
    &[data-position="bottom"]::before {
        top: 150%;
        transform: translate3d(-10px, 5px, 0px)
    }

    &::before {
        content: attr(data-tooltip);
        position: absolute;
        min-width: 60px;
        max-width: 300px;
        display: block;
        padding: 3px;
        top: -50px;
        font-size: 10px;
        color: white;
        background-color: gray;
        text-align: center;
        left: 0;
        z-index: 1;
        opacity: 0;
        pointer-events: none;
    }
}
`;

export default GlobalStyle;
